import React, { useRef, useState } from "react";
import { IonPage, IonContent, IonToolbar, IonFooter, IonIcon, IonText, IonButton, IonHeader, IonModal, IonButtons, IonImg, useIonAlert } from '@ionic/react';
import { useTranslation } from 'react-i18next';

import { useHistory } from "react-router-dom";
import { Capacitor } from "@capacitor/core";

import './KycFlowIntroPage.css';
import { closeOutline, } from "ionicons/icons";
import { useAppDispatch, useAppSelector} from "../../../services/redux/hook";
import AppHeader from "../../../components/AppHeader/AppHeader";
import { ebioroApi, useGetUserInfoQuery} from "../../../services/api/ebioro/ebioro";
import SumsubPlugin from "../../../services/sumsubPlugin/sumsubPlugin";
import SumsubWebSdk from '@sumsub/websdk-react';
import { UserInfo } from "../../../types/types";
import * as Sentry from '@sentry/react';

const ebioroAuthDomain = import.meta.env.VITE_API_AUTH_DOMAIN || '';

const KycFlowIntroPage: React.FC<any> = () => {

    const dispatch = useAppDispatch();
    const [kycToken, setKycToken] = useState('');
    const [kycTestEnvironment, setKycTestEnvironment] = useState(false);
    const [verificationConfig, setVerificationConfig] = useState({});
    const [showVerificationScreen, setShowVerificationScreen] = useState(false);
    const registrationLevel = import.meta.env.VITE_KYC_REGISTRATION_LEVEL;
    const verificationScreenModal = useRef<HTMLIonModalElement>(null);
    const ebioroAuthToken = useAppSelector((state) => state.sep10AuthToken.tokens[ebioroAuthDomain]);
    const {data:userInfo,isSuccess:userInfoSuccess} = useGetUserInfoQuery(ebioroAuthToken,{skip:(ebioroAuthToken===''||ebioroAuthToken===undefined),pollingInterval:20000});
  
    const { t, i18n } = useTranslation();
    const history = useHistory();
    const [present] = useIonAlert();

    const presentErrorAlert = (error: any) => {

        present({
            header: 'Error',
            message: `${error.data}`,
            buttons: [
                {
                    text: 'Close',
                    role: 'cancel',
                    handler: () => {
                        return
                    }
                }
            ],

        })

    }

    const openVerificationScreen = async () => {

        setShowVerificationScreen(true);
    }

    const openNativeVerificationScreen = async (kycTokenResponse: any) => {

        try {

            SumsubPlugin.launch({ accessToken: kycTokenResponse.accessToken })

        } catch (error) {

            Sentry.captureException(error)

        }


    }

    const getKYCToken = async () => {

        const { data: kycTokenResponse, error } = await dispatch(ebioroApi.endpoints.getKYCToken.initiate(registrationLevel as string));
        return kycTokenResponse.accessToken

    }

    const verify = async () => {

        try {

            const user = await dispatch(ebioroApi.endpoints.getUserInfo.initiate({}, { forceRefetch: true })).unwrap();

            const kyc_crypto_status = user?.kyc_status_crypto;

            if (kyc_crypto_status === 'NEEDS_INFO') {
                 
                startIDVerification(user);
                return;
            }

            else if (!user.proof_of_residence_id) {

                history.push('/signup/address')

            }

            else {

                history.push('/signup/notification');


            }

        } catch (error) {

            Sentry.captureException(error)

            presentErrorAlert({ data: t('application.uncaught.ERROR') })
            return

        }

    }


    const startIDVerification = async (userInfo: UserInfo) => {

        const verifyConfig = {
            email: userInfo.email,
            phone: userInfo.mobile_number,
        }

        try {

            const response = await dispatch(ebioroApi.endpoints.getKYCToken.initiate(registrationLevel as string)).unwrap(); // we are putting here just XLM as the default asset to start the verification flow
            setKycToken(response.accessToken);
            setKycTestEnvironment(response.testEnvironment);
            setVerificationConfig(verifyConfig);

            if (response) {

                Capacitor.getPlatform() === 'web' ? openVerificationScreen() : openNativeVerificationScreen(response)
            }

        } catch (error) {

            Sentry.captureException(error)

            presentErrorAlert({ data: t('application.uncaught.ERROR') })
            return

        }

    }

    return (
        <IonPage>
            <IonHeader className="ion-no-border" >
                <IonToolbar className="back_button">
                    <AppHeader
                        title={t('kyc.flow.intro.HEADER') as string}>
                    </AppHeader>
                </IonToolbar>

            </IonHeader>
            <IonContent>

                <IonModal
                    ref={verificationScreenModal}
                    isOpen={showVerificationScreen}
                    trigger='open-verificationScreen'
                >

                    <IonContent>

                        <IonHeader className="ion-no-border" >
                            <IonToolbar >
                                <IonButtons slot="start">
                                    <IonButton onClick={() => { verificationScreenModal.current?.dismiss() }}>
                                        <IonIcon slot="icon-only" icon={closeOutline} color="danger" />
                                    </IonButton>
                                </IonButtons>
                            </IonToolbar>

                        </IonHeader>

                        <SumsubWebSdk
                            accessToken={kycToken}
                            expirationHandler={getKYCToken}
                            config={verificationConfig}
                            onMessage={''}
                            onError={''}
                        />
                    </IonContent>

                </IonModal>

                <div className="ion-text-center">
                    <IonImg className="profile_img" src="/assets/img/new_profile.png" />
                </div>
                <div>

                    <IonText >
                        <p className="kycIntroSubheaderText ion-text-wrap" >{t('kyc.flow.intro.SUBHEADER')}</p>
                    </IonText>

                </div>
            </IonContent>

            <IonFooter className="ion-no-border">
                <IonToolbar>
                    <IonButton
                        type="submit"
                        onClick={() => verify()}

                        expand="block"
                        id='pageFooterButton'
                        >
                            

                            {userInfo?.kyc_status_crypto==="NEEDS_INFO"?t('kyc.flow.intro.BTN-START'):t('kyc.flow.intro.BTN')}

                    </IonButton>
                </IonToolbar>
            </IonFooter>
        </IonPage>
    )

}

export default KycFlowIntroPage